import React from 'react';
import { Shield } from 'lucide-react';
import { useToast } from '../../../../../components/common/Toast';
import { useAccessTheme } from '../useAccessTheme';
import IdentityProviderModalShell from './IdentityProviderModalShell';
import { CapabilityCheckList } from './ProviderBadges';
import { DEMO_SETUP_MESSAGE } from './identityProviderTypes';

interface OktaSetupModalProps {
  onClose: () => void;
}

const OktaSetupModal: React.FC<OktaSetupModalProps> = ({ onClose }) => {
  const t = useAccessTheme();
  const { showToast } = useToast();

  return (
    <IdentityProviderModalShell
      title="Connect Okta"
      icon={<Shield className="w-5 h-5" />}
      onClose={onClose}
      footer={
        <button
          type="button"
          onClick={() => showToast({ type: 'info', message: DEMO_SETUP_MESSAGE })}
          className={'px-4 py-2 rounded-lg text-sm font-medium ' + t.btnPrimary}
        >
          Connect Okta
        </button>
      }
    >
      <div>
        <h4 className={`text-sm font-semibold mb-2 ${t.title}`}>Directory synchronization</h4>
        <CapabilityCheckList items={['Users', 'Groups']} />
      </div>
      <div>
        <h4 className={`text-sm font-semibold mb-2 ${t.title}`}>Authentication</h4>
        <CapabilityCheckList items={['Single Sign-On']} />
      </div>
    </IdentityProviderModalShell>
  );
};

export default OktaSetupModal;
